<script setup>
import { Inertia } from '@inertiajs/inertia'

import { useAuthStore } from '@/Stores/auth'
import { ref, defineAsyncComponent } from 'vue'
import BlockLoader from "@/Shared/VisualComponents/BlockLoader"

import { events, fetchEventsFromWordpress, fetchingEventsFromWordpress } from "@/Mixins/FetchesEventsFromWordpress";

const props = defineProps({
	eventData: {
		type: Object,
		required: true,
	},
})

// we'll be swapping out the list component wholesale depending on who is viewing the page
// admin vs other users
const AsyncComp = defineAsyncComponent({
	loader: () => {
		return new Promise((resolve) => {
			fetchEventsFromWordpress().then(() => {
				const auth = useAuthStore()
				if (auth.isAdmin) {
					resolve(import('@/Pages/Events/List.vue'))
				} else {
					resolve(import('@/Pages/Events/List.vue'))
				}
			})
		})
	},
	loadingComponent: BlockLoader,
	timeout: 5000,
})

function viewEvent(id){
	// inertia route to view event
	Inertia.visit(route('dashboard.events.show', id))
}

</script>

<template>
	<div class="relative">
		<AsyncComp
			:events="events" 
			:event-data="eventData"
			@change-show-past-events="fetchEventsFromWordpress"
			:loading-events="fetchingEventsFromWordpress"
			@view-event="viewEvent"
		/>
	</div>
</template>
